import { configureStore } from '@reduxjs/toolkit';
import authReducer from './slices/authSlice';
import uiReducer from './slices/uiSlice';
import registrationReducer from './slices/registrationSlice';
import profileReducer from './slices/profileSlice';
import staffReducer from './slices/staffSlice';
import resourceReducer from './slices/resourceSlice';
import bookingsReducer from './slices/bookingSlice';
import invoiceReducer from './slices/invoiceSlice';
import jobReducer from './slices/jobSlice';
import quoteReducer from './slices/quoteSlice';
import notificationReducer from './slices/notificationSlice';
import loanCarAllocationsReducer from './slices/loanCarAllocationSlice';
import profileWorkItemReducer from './slices/profileWorkItemSlice';
import customerSearchReducer       from './slices/customerSearchSlice';
import vehicleServiceRecordsReducer from './slices/vehicleServiceRecordsSlice';
import repcoImportReducer from './slices/repcoImportSlice';
import fleetReducer from './slices/fleetSlice';
import fleetVehiclesReducer from './slices/fleetVehicleSlice';
import fleetBookingsReducer from './slices/fleetBookingSlice';
import fleetInvoicesReducer from './slices/fleetInvoiceSlice';
import customerFeedbackReducer from './slices/customerFeedbackSlice';
import fleetServiceRecordsReducer from './slices/fleetServiceRecordSlice';
import preBookingsReducer from './slices/phoneBookingSlice';

export const store = configureStore({
    reducer: {
        auth: authReducer,
        ui: uiReducer,
        registration: registrationReducer,
        profiles: profileReducer,
        staff: staffReducer,
        resources: resourceReducer,
        bookings: bookingsReducer,
        invoices: invoiceReducer,
        jobs: jobReducer,
        quotes: quoteReducer,
        notifications: notificationReducer,
        loanCarAllocations: loanCarAllocationsReducer,
        profileWorkItems: profileWorkItemReducer,
        customerSearch: customerSearchReducer,
        vehicleServiceRecords: vehicleServiceRecordsReducer,
        repcoImport: repcoImportReducer,
        fleet: fleetReducer,
        fleetVehicles: fleetVehiclesReducer,
        fleetBookings: fleetBookingsReducer,
        fleetInvoices: fleetInvoicesReducer,
        customerFeedback: customerFeedbackReducer,
        fleetServiceRecords: fleetServiceRecordsReducer,
        preBookings: preBookingsReducer,
    },
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({
            serializableCheck: {
                ignoredActions: ['auth/loginUser/fulfilled'],
            },
        }),
});

export default store;